import { jsPDF } from 'jspdf'
import { loadImage } from './cv'

/** Combine processed pages into a single PDF document. */
export async function buildPDF(pages) {
  const imgs = await Promise.all(pages.map((p) => loadImage(p.processedDataUrl)))
  let doc = null
  for (const img of imgs) {
    const w = img.naturalWidth
    const h = img.naturalHeight
    const orientation = w > h ? 'l' : 'p'
    if (!doc) {
      doc = new jsPDF({ unit: 'px', format: [w, h], orientation, hotfixes: ['px_scaling'] })
    } else {
      doc.addPage([w, h], orientation)
    }
    doc.addImage(img, 'JPEG', 0, 0, w, h)
  }
  return doc
}

/** Build the PDF and return it as a base64 data URL for upload. */
export async function pdfDataUrl(pages) {
  const doc = await buildPDF(pages)
  return doc.output('datauristring')
}
